<script lang="ts">
  export let customClass = '';
  export let color = '#475467';
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={customClass}
>
  <path
    d="M18 6L6 18M6 6L18 18"
    stroke={color}
    style="stroke:{color};stroke-opacity:1;"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
